import React from 'react';
import PropTypes from 'prop-types';

const Contract = props => {
  return (
    <div className='status'>
      <div className='status__text text-left' dangerouslySetInnerHTML={ { __html: props.children } }>
        { /* TODO: Sanitize HTML */ }
      </div>
    </div>
  );
};

Contract.propTypes = {
  children: PropTypes.node
};

export default Contract;
